const note = {
    version: '1.2.1',
    date: '2026-09-18',
    tags: ['Fix'],
    body: `
- **Tid på en intern matter er altid Non Billable.** Vælger du en matter, hvor klienten er Moalem Weitemeyer, står Billing Type som Non Billable med det samme, og den bliver stående uanset hvilken Work Type du vælger bagefter. Det gælder både Frontend (Kalenderen) og Backend, så de to viser nu det samme.
`,
};

export default note;
